import { createSelector } from "redux-starter-kit";
import { isEmpty } from "lodash";

export default createSelector(
  ["invited.exchangePlaidSuccess"],
  payload => !isEmpty(payload)
);
